const cardModule = {
  // other module props
  id: "abd95f81-5fcf-3453-aeb3-b1a790870f36",
  config: {
    media: {
      media: {
        url: "https://tc-media.job-shop.com/content-modules/cover/header/cover-header.jpg",
        // url: 'https://archive.org/download/BigBuckBunny_124/Content/big_buck_bunny_720p_surround.mp4',
        // url: "https://css-tricks-post-videos.s3.us-east-1.amazonaws.com/708209935.mp4",
        // mediaType: 'image',
        mediaType: "image",
      },
      corners: {
        label: "Round", //Round, Square
        value: "round",
      },
    },
    ctaButton: {
      text: "Learn More",
      fillStyle: {
        label: "Fill", // Fill, Border
        value: "fill",
      },
      corners: {
        label: "Square", //Round, Square
        value: "square",
      },
      link: {
        type: {
          label: "External Link", // external uses url for CtaButton
          value: "external", //or internal, then scrollTarget is used
        },
        url: "https://www.example.com",
        scrollTarget: {
          label: "FAQ",
          value: "7c205826-8720-3b35-884d-b4aa2a32b7f9",
        },
        target: {
          label: "New Tab",
          value: "_blank",
        },
      },
      backgroundColor: {
        label: "Light Slate Grey",
        value: "lightslategray",
      },
      textColor: {
        label: "White",
        value: "white",
      },
    },
    header: {
      isTextInCaps: true,
      text: "Hello to All",
      textColor: {
        label: "Black 4",
        value: "#444",
      },
    },
    text: {
      text: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
      textColor: {
        label: "Black 4",
        value: "#444",
      },
    },
  },
};

export default cardModule;
